const getRaceTypeDropdownQuery = /* GraphQL */ `
  query GetRaceTypeDropdown($raceTypeId: Int, $selectedFacetData: SelectedFacetDataDMInput = null) {
    raceTypeData: raceTypeDropdown(raceTypeId: $raceTypeId, selectedFacetData: $selectedFacetData) {
      raceTypeDropdown {
        optionId
        displayName
        marketId
        superMarketId
        shopUrl
        searchUrl
      }
      stockEngineDropdown {
        optionId
        marketId
        superMarketId
        displayName
        shopUrl
        searchUrl
        engineIds {
          engineManufacturerId
          engineMakeId
          engineSeriesId
          engineConfigurationId
          engineQualifierId
          engineVersionId
          engineDisplacementId
          engineCodeId
          engineCamshaftTypeId
          engineFuelSystemId
        }
      }
    }
  }
`

export default getRaceTypeDropdownQuery
